import React from 'react';

export function EventsIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none">
      <path
        stroke="#000"
        strokeWidth="1.5"
        d="M16 4H4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1ZM3 8h14"
      />
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="M7 2v3M13 2v3"
      />
      <path
        fill="#000"
        d="M7 11.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M10 11.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M13 11.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M7 14.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M10 14.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
      />
    </svg>
  );
}
